import React from 'react';
var Sphere = function (_a) {
    var draw = _a.draw, background = _a.background;
    return (React.createElement("path", { pointerEvents: "none", fill: background, d: draw({ type: 'Sphere' }) }));
};
export default Sphere;
